import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Lead, Meta } from 'utils/types';
import { useTour } from '@reactour/tour';
import { omit } from 'lodash';

import { leadsTransformer } from '../transformers';
import c from '../utils/constants';

interface Result {
  data: Lead[];
  meta: Meta;
}

export default function useGetLeads(params: { [key: string]: any } = {}) {
  const { accountId, accountUserId } = useAdminParams();
  const { isOpen } = useTour();
  const { state } = useProvider();
  const args = state;

  return useQuery<Result, Error>({
    queryKey: [c.LEADS, params],
    queryFn: async () => {
      const api = new Api(args);

      if (params?.keyword) {
        params.keyword = params.keyword.replace('+', '');
      }

      if (params?.sortBy) {
        params.sortBy = params.sortBy.replace('data_', 'data.');
      }

      const data = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/contacts/leads',
            params: omit(params, 'enabled'),
            transformer: leadsTransformer.leads,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/contacts/leads`,
            params: omit(params, 'enabled'),
            transformer: leadsTransformer.leads,
          },
        }),
      );

      return data;
    },
    enabled: !isOpen,
  });
}
